var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeRc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 302.60351107634415 88.47697922515545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-right-right-button-1",
    opacity: 1,
    fillRule: "evenodd",
    d: "M251.60351107634415,16.49999999999997 L302.60351107634415,64.49999999999997 L275.10351107634415,88.47697922515542 L10.68461562032291,88.47697922515542 L-2.2737367544323206e-13,78.75602534086283 L-4.547473508864641e-13,-2.842170943040401e-14 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-2",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(0,187,255)",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(0,187,255)",
    stopOpacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-right-right-button-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeRc);
export default __webpack_public_path__ + "static/media/shape-rc.29e4d3a40143720443eb3b256332a2c0.svg";
export { ForwardRef as ReactComponent };